import EventData from "./EventData.vue";
export default EventData;